import { render } from "./MiniWizardStickyCollapsible.vue?vue&type=template&id=591a5b5e"
import script from "./MiniWizardStickyCollapsible.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyCollapsible.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__